// extracted by mini-css-extract-plugin
export default {"main":"Card_main__UVh3B","title":"Card_title__qr0vL","text":"Card_text__50p9u"};